import { VenueRoomMediaLinkComponent } from './../venue-room-media-link/venue-room-media-link.component';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { VenueViewModel } from '../../models-views/venue.view.model';
import { QuickAddService } from '../../services/quick-add.service';
import { AppCommon } from '../../providers/app-common';
import { NzModalService } from 'ng-zorro-antd/modal';
// import {VenueRoomMediaLinkComponent}
// import

@Component({
  selector: 'app-venue-add-room',
  standalone: false,
  templateUrl: './venue-add-room.component.html',
  styleUrl: './venue-add-room.component.scss',
})
export class VenueAddRoomComponent {
  @Input() data: any;
  @Input() venueID: any;
  @Input() isVisible = false;
  @Input() allRoomData: any[] = [];
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() closeDrawerData = new EventEmitter<boolean>();

  roomForm: FormGroup;
  loggedInUser: any;
  mediaLinkForm: FormGroup;
  loading = false;
  mediaLinks: any = [];
  pendingMediaLinkDeleteIds: number[] = [];
  roomId: any = '';
  venueRoomId: any = '';
  venueRoonLinkArr: any = [];
  private numericFields = [
    'room_type',
    'room_length',
    'max_capacity',
    'seating_capacity_theatre',
    'capacity_long_table',
    'capacity_classroom',
    'capacity_boardroom',
    'capacity_banquet_rounds',
    'capacity_u_shape',
    'capacity_reception_standing',
    'total_space',
    'ceiling_height',
    'tv_size',
    'screen_size',
  ];

  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private vm: VenueViewModel,
    private quickAddService: QuickAddService,
    private modal: NzModalService
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.vm.VenueAddRoomComponent = this;

    // Main Room Form
    this.roomForm = this.fb.group({
      room_type: ['', Validators.required],
      room_name: ['', Validators.required],
      room_length: [null, Validators.required],
      max_capacity: [null, Validators.required],

      // Optional seating capacities
      seating_capacity_theatre: [null],
      capacity_long_table: [null],
      capacity_classroom: [null],
      capacity_boardroom: [null],
      capacity_banquet_rounds: [null],
      capacity_u_shape: [null],
      capacity_reception_standing: [null],

      total_space: [null],
      ceiling_height: [null],
      natural_light: [false],
      soundproofing: [false],
      room_specifications: [''],
      breakout_rooms: [''],
      in_house_av: [false],
      stage_availability: [false],
      led_wall: [''],

      // TV and projector
      tv: [false],
      tv_size: [null],
      projector_and_screen: [false],
      screen_size: [null],

      media_link: [''],
    });

    // Conditional Validators for TV Size
    this.roomForm.get('tv')?.valueChanges.subscribe((checked) => {
      const tvSizeControl = this.roomForm.get('tv_size');
      if (checked) {
        tvSizeControl?.setValidators([Validators.required]);
      } else {
        tvSizeControl?.clearValidators();
        tvSizeControl?.setValue(null); // reset when unchecked
      }
      tvSizeControl?.updateValueAndValidity();
    });

    // Conditional Validators for Projector Screen Size
    this.roomForm
      .get('projector_and_screen')
      ?.valueChanges.subscribe((checked) => {
        const screenSizeControl = this.roomForm.get('screen_size');
        if (checked) {
          screenSizeControl?.setValidators([Validators.required]);
        } else {
          screenSizeControl?.clearValidators();
          screenSizeControl?.setValue(null); // reset when unchecked
        }
        screenSizeControl?.updateValueAndValidity();
      });

    this.mediaLinkForm = this.fb.group({
      name: ['', Validators.required],
      url: ['', Validators.required],
      type: ['1', Validators.required], // default Google Drive
    });

    this.vm.roomMediaLinks.subscribe((res: any) => {
      this.mediaLinks = res?.data || []; // update parent state
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data !== undefined) {
      this.roomForm.patchValue({
        ...this.data,
        room_type: this.toNumberOrNull(this.data.room_type),
      });
    }
    if (this.data && this.data.id) {
      this.venueRoomId = this.data.id;
    }
    if (this.data && this.data.venue_details && this.data.venue_details.id) {
      this.venueID = this.data.venue_details.id;
    }

    if (
      this.data &&
      this.data.media_link_details &&
      this.data.media_link_details.length > 0
    ) {
      this.mediaLinks = this.data.media_link_details;
    } else {
      this.mediaLinks = [];
    }
    this.pendingMediaLinkDeleteIds = [];
  }

  handleCancel(): void {
    this.isVisible = false;
    this.roomForm.reset();
    this.pendingMediaLinkDeleteIds = [];
    this.closeDrawer.emit(false);
  }

  // save(): void {
  //   if (this.roomForm.invalid) {
  //     this.message.error('Please fill all required fields correctly');
  //     return;
  //   }

  //   const formData = {
  //     ...this.roomForm.value,
  //     created_by: this.data ? undefined : this.loggedInUser.id,
  //     modified_by: this.data ? this.loggedInUser.id : undefined,
  //     venue: this.venueID,
  //   };

  //   formData.media_link = this.mediaLinks.map((link: any) => link.id);

  //   if (this.data && this.venueID) {
  //     this.vm.updateRoom(formData, this.data.id, 'venueAddRoomComponent');
  //   } else if (this.venueID) {
  //     this.vm.createRoom(formData);
  //   } else {
  //     this.roomCreated();
  //   }
  // }

  save(): void {
    if (this.roomForm.invalid) {
      this.message.error('Please fill all required fields correctly');
      return;
    }

    // Clone form values
    const rawFormData = {
      ...this.roomForm.value,
      created_by: this.data ? undefined : this.loggedInUser.id,
      modified_by: this.data ? this.loggedInUser.id : undefined,
      venue: this.venueID,
    };

    // Remove empty/null/undefined fields
    const formData: any = {};
    Object.keys(rawFormData).forEach((key) => {
      const value = this.numericFields.includes(key)
        ? this.toNumberOrNull(rawFormData[key])
        : rawFormData[key];
      if (value !== '' && value !== null && value !== undefined) {
        formData[key] = value;
      }
    });

    // Handle media links separately
    if (this.mediaLinks?.length) {
      formData.media_link = this.mediaLinks
        .map((link: any) => this.toNumberOrNull(link.id))
        .filter((id: number | null) => id !== null);
    }

    if (this.data && this.venueID) {
      this.vm.updateRoom(formData, this.data.id, 'venueAddRoomComponent');
    } else if (this.venueID) {
      this.vm.createRoom(formData);
    } else {
      this.roomCreated();
    }
  }

  private toNumberOrNull(value: any): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }

    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? null : numericValue;
  }


  roomUpdated() {
    let d = this.roomForm.value;
    d['id'] = this.data.id;
    this.deletePendingMediaLinks(() => {
      this.closeDrawerData.emit(d);
      this.isVisible = false;
      this.roomForm.reset();
      this.pendingMediaLinkDeleteIds = [];
      this.quickAddService.refreshData.next(true);
      this.closeDrawer.emit(true);
    });
  }

  roomCreated() {
    this.closeDrawerData.emit(this.roomForm.value);
    this.isVisible = false;
    this.roomForm.reset();
    this.pendingMediaLinkDeleteIds = [];
    this.quickAddService.refreshData.next(true);
    this.closeDrawer.emit(true);
  }

  ngOnInit(): void {
    if (this.roomId) {
      this.fetchMediaLinks();
    }
  }

  fetchMediaLinks(): void {}

  deleteMediaLink(id: number, index: number): void {
    const mediaLinkId = this.toNumberOrNull(id);
    if (mediaLinkId !== null && !this.pendingMediaLinkDeleteIds.includes(mediaLinkId)) {
      this.pendingMediaLinkDeleteIds.push(mediaLinkId);
    }
    this.mediaLinks.splice(index, 1);
    this.mediaLinks = [...this.mediaLinks];
    this.message.success('Media link removed. Click Update to delete it permanently.', {
      nzDuration: 1500,
    });
  }

  private deletePendingMediaLinks(onComplete: () => void): void {
    const ids = [...this.pendingMediaLinkDeleteIds];
    if (!ids.length) {
      onComplete();
      return;
    }

    let completedCount = 0;
    const completeOne = () => {
      completedCount += 1;
      if (completedCount === ids.length) {
        this.pendingMediaLinkDeleteIds = [];
        onComplete();
      }
    };

    ids.forEach((id) => {
      this.vm.deleteVenueRoomLink(id, completeOne, completeOne);
    });
  }

  openAddLink(): void {
    const modalRef = this.modal.create<VenueRoomMediaLinkComponent>({
      nzTitle: 'Add Media Link',
      nzContent: VenueRoomMediaLinkComponent,
      nzFooter: null,
      nzData: {
        venueID: this.venueID,
        venueRoomId: this.venueRoomId,
      },
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        this.mediaLinks.push(result);
      }
    });
  }

  // Open modal to edit an existing link
  openEditLink(link: any, index: number): void {
    const modalRef = this.modal.create<VenueRoomMediaLinkComponent>({
      nzTitle: 'Edit Media Link',
      nzContent: VenueRoomMediaLinkComponent,
      nzFooter: null,
      nzData: {
        venueID: this.venueID,
        venueRoomId: this.venueRoomId,
        mode: 'edit', // extra flag to tell child this is edit mode
        mediaLink: link, // send the link to be edited
      },
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) {
        // replace the edited link in the array
        this.mediaLinks[index] = result;
      }
    });
  }

  setLinkDetails(link: any): void {
    // if single link returned → push to mediaLinks
    if (link) {
      this.mediaLinks.push(link);
    }
  }

  onLinksChanged(updatedLinks: any[]): void {
    // if whole list returned → replace table
    this.mediaLinks = [...updatedLinks];
  }
}
